// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Register_modalOverlay__BE69-","modalContent":"Register_modalContent__4NaiG","closeButton":"Register_closeButton__YBXXp"};